// @flow
import React from 'react';

import { Select } from '@duxton-web/ui';
import { colorContentPlaceholder } from '@duxton-web/design-tokens/themes/light';

import MultiSelectDropdown from 'omega-rtc/components/form/ucd/common/MultiSelectDropdown';
import { OBJECTIVES_ICON_LABEL } from 'omega-rtc/constants/ucd';

const objectiveOptions = Object.entries(OBJECTIVES_ICON_LABEL).map(
  ([key, value]) => ({
    value: key,
    label: value.label,
  }),
);

const BusinessObjectiveSelector = ({
  multiple,
  initialValue,
  onChange,
  ...props
}) => {
  if (multiple) {
    return (
      <MultiSelectDropdown
        width={'100%'}
        height={'43px'}
        menuWidth={'100%'}
        placeholder="Business Objective"
        multiValuePlaceholder="Multiple Business Objectives"
        initialValue={initialValue}
        options={objectiveOptions}
        onChange={onChange}
        buttonStyle={{
          borderRadius: '14px',
        }}
        placeholderStyle={{
          color: colorContentPlaceholder,
        }}
        {...props}
      />
    );
  }

  return (
    <Select
      placeholder="Select Business Objective"
      size="default"
      options={objectiveOptions}
      onChange={onChange}
      {...props}
    />
  );
};

export default BusinessObjectiveSelector;
